import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getIssuesComponent, getErrorIssues, getWarningIssues } from '../../../../../../../utils/validationSummary';

class ConfigLockForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            keys: this.getKeys(!isNaN(props.property.value) ? props.property.value : 0, props.numberOfKeys),
        };

        this.getKeys = this.getKeys.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getKeys(value, numberOfKeys) {
        let keys = [];
        for (let i = 0; i < numberOfKeys; i++) {
            keys.push(this.getSplitByNumber(value, i));
        }
        return keys;
    }

    getSplitByNumber(number, index) {
        return ((number & (255 << (index * 8))) >>> (index * 8));
    }

    getPasswordFromInputs() {
        let value = 0;
        for (let i = 0; i < this.props.numberOfKeys; i++) {
            value |= this.state.keys[i] << (i * 8);
        }
        return value >>> 0;
        //return ((index3 << 24) | (index2 << 16) | (index1 << 8) | (index0 << 0)) >>> 0;
    }

    handleChange(e) {

        const value = parseInt(e.target.value ? e.target.value : 0);
        const index = e.target.name;
        this.setState(prevState => {
            const keys = prevState.keys;
            keys[index] = value;

            return {
                keys: keys
            };
        }, () => {
            const number = this.getPasswordFromInputs();
            this.props.handleChange(this.props.property.info.name, number ? number : "Off");
        });
    }

    renderKeys(className) {
        return this.state.keys.map((key, i) => {
            const index = this.props.numberOfKeys - i - 1;

            let classNameValidated = this.state.keys[index] <= 255 ? className : className + ' danger';

            return (
                <Col sm="3" style={{ display: "flex", padding: "0" }} key={index}>
                    <input
                        disabled={this.props.disabled}
                        key={index}
                        style={{ display: "flex", width: '3.25rem', marginRight: '0.25rem' }}
                        className={classNameValidated}
                        name={index}
                        // text or number?
                        type="number"
                        min={0}
                        max={255}
                        value={this.state.keys[index]}
                        onChange={this.handleChange} />
                </Col>
            );
        });
    }

    // getMinWidth() {
    //     return ((60+10) * this.props.numberOfKeys + 10) + 'px';
    // }

    componentDidUpdate(prevProps, prevState) {
        const newKeys = this.getKeys(prevProps.property.value, prevProps.numberOfKeys);

        if (prevProps.disabled === true && (this.props.disabled === false)) {
            this.setState({ keys: newKeys });
        }
    }

    render() {
        const errors = getErrorIssues(this.props.issues, this.props.property);
        const warnings = getWarningIssues(this.props.issues, this.props.property);
        const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

        return (
            <div className="flex-column">
                <Row>
                    {this.renderKeys(className)}
                </Row>
                <Row>
                    {getIssuesComponent(errors, warnings)}
                </Row>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfigLockForm);
